import { Helmet } from 'react-helmet-async';

export default function NewPostPage() {
  return (
    <div style={{ padding: '20px' }}>
      <Helmet>
        <title>New Post - QuestFlow Admin</title>
      </Helmet>
      <h1>New Post</h1>
      <p>Post editor - Coming soon</p>
    </div>
  );
}
